export default "__VITE_ASSET__iJ0dQGZx__"